<div id="selector">
    @if (showUploadField()) {
        <ap-dropzone
            data-bb="warning-maxamount"
            (fileDropped)="addFiles($event)"
            [isDisabled]="isDisabled()"
            [maximumFilesReached]="reachedMaximumFileAmount"
            data-testid="file-selector-dropzone"
            class="ap-sm-hide"
        >
            @if (!reachedMaximumFileAmount) {
                <p>
                    {{
                        'file.selector.dropZoneText'
                            | apContent
                                : {
                                      fileExtensions: getFileExtensionsString(),
                                      sizeLimit: (fileSizeLimitInMB() * 1024 * 1024 | apBytes)
                                  }
                    }}
                    @if (allowMultiple) {
                        <span>{{ 'file.selector.dropZoneText.allowMultiple' | apContent }}</span>
                    }
                </p>
            }
            @if (reachedMaximumFileAmount) {
                <p data-bb="warning-maxamount">
                    {{ 'file.selector.warning.amount' | apContent: { fileAmount: maxFilesAllowed().toString() } }}
                </p>
            }
            @if (!reachedMaximumFileAmount) {
                <ap-file-upload-button
                    [isDisabled]="isDisabled()"
                    (fileChanged)="addFiles($event)"
                    [fileFormControl]="selectorFormControl()"
                    [accept]="getFileExtensionsString()"
                    [label]="'file.selector.buttonLabel' | apContent"
                    [allowMultiple]="allowMultiple"
                    data-testid="upload-button"
                >
                </ap-file-upload-button>
            }
        </ap-dropzone>
        <p class="ap-small ap-lt-md-hide" data-testid="file-type-message">
            <ap-content
                [key]="additionalTextKey"
                [params]="{
                    fileExtensions: getFileExtensionsString(),
                    sizeLimit: (fileSizeLimitInMB() * 1024 * 1024 | apBytes)
                }"
            >
            </ap-content>
        </p>
        <ap-form-errors data-testid="selector-errors" [control]="selectorFormControl()" [messages]="selectorMessages"></ap-form-errors>
        <div class="ap-gt-sm-hide">
            <ap-file-upload-button
                [isDisabled]="isDisabled()"
                (fileChanged)="addFiles($event)"
                [label]="'file.selector.buttonLabel' | apContent"
                [fileFormControl]="selectorFormControl()"
                [accept]="getFileExtensionsString()"
                data-testid="upload-button"
            >
            </ap-file-upload-button>
            <ap-form-errors
                data-testid="document-type-errors"
                [control]="selectorFormControl()"
                [messages]="documentTypeMessages"
            ></ap-form-errors>
        </div>
    }

    @for (validator of validators; track validator) {
        @if (validator.showNotification) {
            <ap-notification
                [status]="validator.getNotification().type"
                [closeable]="true"
                [attr.data-bb]="validator.getNotification().testId"
                (closeClicked)="validator.showNotification = false"
            >
                <span [innerHTML]="validator.getNotification().content"></span>
            </ap-notification>
        }
    }
    @if (hasFailedFiles()) {
        <ap-notification status="error">
            <ap-content key="file.selector.error.failed"> </ap-content>
        </ap-notification>
    }

    <table ap-table [dataSource]="files" [responsive]="false" name="FileTable" data-testid="file-table">
        <caption class="ap-sr-only">
            {{
                'file.selector.table.title' | apContent
            }}
        </caption>
        <ng-container apColumnDef="NAME">
            <th ap-header-cell *apHeaderCellDef>
                {{ 'file.selector.table.header.name' | apContent }}
            </th>
            <td ap-cell *apCellDef="let element" title="{{ element.name }}" [class.color-error]="element.status === uploadStatus.FAILED">
                {{ element.name | apFileName }}
            </td>
        </ng-container>

        <ng-container apColumnDef="SIZE">
            <th ap-header-cell *apHeaderCellDef>
                {{ 'file.selector.table.header.size' | apContent }}
            </th>
            <td ap-cell *apCellDef="let element" [class.color-error]="element.status === uploadStatus.FAILED">
                @if (showFileSize(element.status)) {
                    <span>{{ element.size | apBytes }}</span>
                }
                @if (element.status === uploadStatus.UPLOADING) {
                    <span><ap-progress [small]="true" [progress]="element.progress"></ap-progress></span>
                }
            </td>
        </ng-container>

        <ng-container apColumnDef="REMOVE">
            <th ap-header-cell *apHeaderCellDef>
                {{ 'file.selector.table.header.remove' | apContent }}
            </th>
            <td ap-cell *apCellDef="let element" apCellNoPadding>
                @if (showRemoveButton(element.status)) {
                    <ap-action-icon
                        [ariaLabel]="'file.selector.file.remove' | apContent: { fileName: element.name }"
                        name="removeButton"
                        (onClick)="deselectFile(element)"
                        data-testid="file-remove-button"
                    >
                        <ap-icon name="delete" color="secondary" [manualSize]="20"></ap-icon>
                    </ap-action-icon>
                }
                @if (element.status === uploadStatus.COMPLETE) {
                    <ap-icon name="checkmark" color="secondary" [manualSize]="14"></ap-icon>
                }
                @if (element.status === uploadStatus.PROCESSING) {
                    <ap-icon name="clock" color="secondary" [manualSize]="20"></ap-icon>
                }
            </td>
        </ng-container>

        <tr ap-header-row *apHeaderRowDef="getHeaderColumns()"></tr>
        <tr ap-row *apRowDef="let row; columns: displayedColumns"></tr>
    </table>

    @if (uploadPreview() && files?.length === 1 && +maxFilesAllowed() === 1) {
        <div class="ap-file-selector__preview" [class]="{ 'ap-file-selector__preview--background': isImage(files[0]) }">
            @if (isImage(files[0])) {
                <img alt="image preview" class="ap-file-selector__preview--image" [src]="getPreview(files[0])" />
            }
            @if (isPDF(files[0])) {
                <object
                    data-testid="object-preview"
                    class="ap-file-selector__preview--object"
                    [data]="getPreview(files[0])"
                    type="application/pdf"
                >
                    <span alt="preview upload"></span>
                </object>
            } @else {
                <iframe
                    data-testid="object-preview"
                    title="preview upload"
                    class="ap-file-selector__preview--iframe"
                    [src]="getPreview(files[0])"
                ></iframe>
            }
        </div>
    }
</div>
